const GradientTextWithBall = ({ text }) => (
  <div className="flex items-end py-4 md:p-0">
    <h2 className="font-bold text-4xl leading-tight md:text-7xl md:leading-snug xl:text-8xl xl:leading-tight text-white z-10 font-gilroy">
      {text}
    </h2>
    <div className="bg-gradient-roaddy-circular w-11 h-11 right-10 md:w-24 md:h-24 md:right-16 xl:w-28 xl:h-28 rounded-full relative xl:right-20"></div>
  </div>
);
export default GradientTextWithBall;
